import { useEffect, useState } from "react";
import { BarChart3 } from "lucide-react";
import { api } from "@/lib/api";

const R = (v) => (
  <span className={`font-bold ${v > 0 ? "text-[#22C55E]" : v < 0 ? "text-[#EF4444]" : "text-zinc-400"}`}>
    {v > 0 ? "+" : ""}{v}R
  </span>
);

export default function StrategyRecordBanner({ onOpen }) {
  const [report, setReport] = useState(null);

  useEffect(() => {
    let dead = false;
    const load = async () => {
      try {
        const { data } = await api.get("/backtest/strategy-report", { timeout: 120000 });
        if (!dead && data?.ok) setReport(data);
      } catch { /* transient */ }
    };
    load();
    const id = setInterval(load, 5 * 60000);
    return () => { dead = true; clearInterval(id); };
  }, []);

  if (!report) return null;
  const all = report.combined;

  return (
    <section className="border-b border-zinc-900 bg-[#0b0b0b] px-4 md:px-6 py-2 flex items-center gap-4 overflow-x-auto"
             data-testid="strategy-record-banner">
      <div className="flex items-center gap-2 text-[10px] font-mono uppercase tracking-widest text-zinc-500 shrink-0">
        <BarChart3 className="h-3.5 w-3.5 text-[#007AFF]" />
        Strategy Backtest · {report.window_days} days
      </div>
      {report.indices.map((r) => (
        <div key={r.symbol} className="flex items-center gap-2 text-[10px] font-mono uppercase tracking-widest shrink-0"
             data-testid={`srb-${r.symbol}`}>
          <span className="text-zinc-400">{r.symbol}</span>
          <span className="text-[#007AFF]">S1</span>{R(r.s1.total_r)}
          <span className="text-[#A855F7]">S2</span>{R(r.s2.total_r)}
        </div>
      ))}
      <div className="flex items-center gap-2 text-[10px] font-mono uppercase tracking-widest shrink-0 border-l border-zinc-800 pl-4"
           data-testid="srb-all">
        <span className="text-white font-bold">ALL</span>
        <span className="text-[#007AFF]">S1</span>{R(all.s1.total_r)}
        <span className="text-zinc-600">{all.s1.win_pct}%</span>
        <span className="text-[#A855F7]">S2</span>{R(all.s2.total_r)}
        <span className="text-zinc-600">{all.s2.win_pct}%</span>
      </div>
      {onOpen && (
        <button onClick={onOpen}
                className="ml-auto shrink-0 text-[9px] font-mono uppercase tracking-widest text-zinc-500 hover:text-white border border-zinc-800 hover:border-[#007AFF] px-2 py-1"
                data-testid="srb-open-report">
          Full Report →
        </button>
      )}
    </section>
  );
}
